import addHistoryEventListener from '../../events/history/history';
import addFontSizeEventListener from '../../events/font-size/font-size';

const loadEventListeners = config => {
  addHistoryEventListener(config);
  addFontSizeEventListener();
};

export default loadEventListeners;
